export const MODAL_DIALOG__PAYOUT_CANCEL_REASON = 'MODAL_DIALOG__PAYOUT_CANCEL_REASON';
export const MODAL_DIALOG__PAYOUT_REQUEST_DETAILS = 'MODAL_DIALOG__PAYOUT_REQUEST_DETAILS';
